//@ts-nocheck

import {FC, useState} from 'react'
import {Button} from '_core'
import {useDispatch, useSelector} from 'react-redux'
import {showMessage} from 'app/redux/messageSlice'
import {
  resetOrderRefundEdit,
  selectRefund,
  selectRefundItems,
  setIsDirty,
  setOrderErrors,
  updateRefundOrder,
} from 'app/features/orders/redux/order/refundSlice'
import {useNavigate} from 'react-router-dom'
import orderEditService from 'app/services/OrderEditService/OrderEditService'
import {RefundOrder} from 'app/features/orders/models/OrderRefundState'
import {RootState} from 'setup'
import eventPublishService from 'app/services/EventPublishService/EventPublishService'
import {eventNames} from 'app/constant'
import { defaultPaymentErrorMessage } from 'app/constant/payment'

interface Props {
  title?: string
  disabled?: boolean
}

const PayConnectRefundButton: FC<Props> = ({title = 'Refund', disabled}) => {
  const dispatch = useDispatch()
  const history = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const refund = useSelector<RootState, RefundOrder>(selectRefund)
  const orderItems = useSelector<RootState, any[]>(selectRefundItems)

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true)
      await partialRefund()
    } catch (err) {
      console.error(err)
      dispatch(
        showMessage({
          text: 'Error occurred while processing your request',
          variant: 'error',
        })
      )
      setIsSubmitting(false)
    }
  }

  const partialRefund = async () => {
    await dispatch(updateRefundOrder(orderItems))
    const posOrderTransaction = await orderEditService.getPosRefundOrder(refund)
    const {transactionId, metaData, paymentReferenceId, orderNumber, totalAmount, paymentType} =
      posOrderTransaction

    const posOrder = {
      amount: totalAmount * -1,
      paymentReferenceId,
      metaData,
      paymentType,
      orderNumber,
      orderId: refund.id,
      orderEditId: refund.orderEditId,
      transactionId,
    }
    if (window.corksy && window.corksy.paymentRelayClient) {
      await window.corksy.paymentRelayClient.mfOrderReturn(posOrder, (paymentResponse: any) => {
        handleCompleteReturn(posOrder.amount, paymentResponse)
      })
    } else {
      dispatch(
        showMessage({
          text: defaultPaymentErrorMessage(),
          variant: 'error',
        })
      )
      await dispatch(resetOrderRefundEdit())
    }
  }

  const handleCompleteReturn = async (amount, paymentResponse) => {
    const {error} = paymentResponse
    if (error) {
      dispatch(setOrderErrors([error.message]))
      dispatch(
        showMessage({
          text: defaultPaymentErrorMessage(error?.message),
          variant: 'error',
        })
      )
    } else {
      await orderEditService.completeCompliancePosTerminalOrderPartialRefund(refund)
      try {
        await eventPublishService.publish({
          message: {id: refund.orderEditId},
          name: eventNames.orderEdit,
        })
      } catch (error) {
        console.error(error)
      }

      dispatch(setIsDirty(false))
      dispatch(
        showMessage({
          text: 'Your order has been updated successfully',
          variant: 'success',
        })
      )
      history(`/orders/${refund.id}/fulfillments/view`)
    }
    setIsSubmitting(false)
  }

  return (
    <div className='me-5'>
      <Button
        id='btnSave'
        type='button'
        title={title}
        isSubmitting={isSubmitting}
        className='btn-primary btn-primary-active'
        onClick={handleSubmit}
        disabled={disabled}
      />
    </div>
  )
}

export default PayConnectRefundButton
